__turbopack_context__.v({
  "attribution_container": "QuoteContent-module-scss-module__gKf86a__attribution_container",
  "author_avatar": "QuoteContent-module-scss-module__gKf86a__author_avatar",
  "author_name": "QuoteContent-module-scss-module__gKf86a__author_name",
  "quote_container": "QuoteContent-module-scss-module__gKf86a__quote_container",
  "quote_mark": "QuoteContent-module-scss-module__gKf86a__quote_mark",
  "quote_text": "QuoteContent-module-scss-module__gKf86a__quote_text",
});
